import React from 'react';
const staffDirectory = [{
  name: 'Robert Palmer',
  role: 'President; Sales',
  ext: '101',
  phone: 'tel:2483800871'
}, {
  name: 'Lonnie Jewell',
  role: 'Vice President; Sales',
  ext: '105',
  phone: 'tel:2483800871'
}, {
  name: 'RJ Palmer',
  role: 'New & Used Machine Sales',
  ext: '100',
  phone: 'tel:2483800871'
}, {
  name: 'Leanne Beasley',
  role: 'Sales Development',
  ext: '102',
  phone: 'tel:2489167707'
}, {
  name: 'Laura Palmer',
  role: 'Controller',
  ext: '107',
  phone: 'tel:2483800871'
}];
export function StaffDirectorySection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-1649">
      <h3 className="text-lg font-bold text-navy mb-4" data-id="element-1650">Our Team</h3>
      <div className="overflow-x-auto" data-id="element-1651">
        <table className="w-full text-sm" data-id="element-1652">
          <tbody data-id="element-1653">
            {staffDirectory.map(person => <tr key={person.name} className="border-b border-gray-100 last:border-0" data-id="element-1654">
                <td className="py-3 pr-4" data-id="element-1655">
                  <span className="font-bold text-gray-900" data-id="element-1656">{person.name}</span>
                  <span className="text-gray-600" data-id="element-1657"> – {person.role}</span>
                </td>
                <td className="py-3 text-right" data-id="element-1658">
                  <a href={person.phone} className="text-orange hover:underline whitespace-nowrap" data-id="element-1659">
                    Ext. {person.ext}
                  </a>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}